import {
  TipoElementoExtraImpalcatoValue,
  TipologiaElementoExtraTableValue,
} from 'constants/inspections';
import { tipologiaElementoExtraOptions } from 'constants/selectOptions';

// Mappa il "Tipo Elemento" (Gerber, Sbalzi, Pendini, Strallo, Altro) alla
// chiave della matrice schede difetti in schedeDifetti.js. Condivisa da L0/L1 e
// dal flusso di copia, per non disallineare la logica di gating.
export const SCHEDA_KEY_MAP_ELEMENTI_EXTRA_IMPALCATO = {
  [TipoElementoExtraImpalcatoValue.Gerber]: 'gerber',
  [TipoElementoExtraImpalcatoValue.Sbalzi]: 'sbalzi',
  [TipoElementoExtraImpalcatoValue.Pendini]: 'pendini',
  [TipoElementoExtraImpalcatoValue.Strallo]: 'strallo',
  [TipoElementoExtraImpalcatoValue.Altro]: 'elementoExtra',
};

// Materiali ammessi per tipo (task11.md, sezione 3). "Altro" ammette tutti i
// materiali, comportamento invariato rispetto a oggi.
const MATERIALI_AMMESSI_PER_TIPO = {
  [TipoElementoExtraImpalcatoValue.Gerber]: [
    TipologiaElementoExtraTableValue.CalcestruzzoArmato,
    TipologiaElementoExtraTableValue.CalcestruzzoArmatoPrecompresso,
    TipologiaElementoExtraTableValue.AcciaioOMetallo,
  ],
  [TipoElementoExtraImpalcatoValue.Sbalzi]: [
    TipologiaElementoExtraTableValue.CalcestruzzoArmato,
  ],
  [TipoElementoExtraImpalcatoValue.Pendini]: [
    TipologiaElementoExtraTableValue.CalcestruzzoArmato,
    TipologiaElementoExtraTableValue.AcciaioOMetallo,
  ],
  [TipoElementoExtraImpalcatoValue.Strallo]: [
    TipologiaElementoExtraTableValue.CalcestruzzoArmatoPrecompresso,
    TipologiaElementoExtraTableValue.AcciaioOMetallo,
  ],
};

// Nessuna scheda finché il "Tipo Elemento" non è stato scelto esplicitamente
// (populateSchedaDifetti gestisce già il caso tipologia non valorizzata).
export const getSchedaDifettiElementoExtraImpalcato = (
  populateSchedaDifetti,
  tipo,
  tipologia
) => {
  const schedaKey = SCHEDA_KEY_MAP_ELEMENTI_EXTRA_IMPALCATO[tipo];
  return schedaKey
    ? populateSchedaDifetti(schedaKey, tipologia)
    : [{ alert: true }];
};

export const getTipologiaOptionsElementoExtraImpalcato = tipo => {
  // "Tipo Elemento" non ancora scelto (es. tornato a "Nessun valore") non va
  // confuso con "Altro" (che ammette davvero tutti i materiali, assente da
  // MATERIALI_AMMESSI_PER_TIPO per scelta): nessuna opzione ammissibile finché
  // non si sceglie un tipo, altrimenti il controllo "tipologia ancora
  // ammissibile" in ElementiExtraForm.jsx trova sempre un match e non svuota
  // più "Tipologia" al reset del Tipo.
  if (!tipo) return [];
  const materialiAmmessi = MATERIALI_AMMESSI_PER_TIPO[tipo];
  if (!materialiAmmessi) {
    return tipologiaElementoExtraOptions;
  }
  return tipologiaElementoExtraOptions.filter(o =>
    materialiAmmessi.includes(o.value)
  );
};
